export default {"src":"__ASTRO_ASSET_IMAGE__CwGP6r5b__","width":11,"height":12,"format":"svg"}